import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private jwtHelper: JwtHelperService, private router: Router, private http: HttpClient) {
  }
  // tslint:disable-next-line:typedef
  async canActivate() {
    const token = localStorage.getItem('accessToken');
    let isTokenValid = false;
    try {
      isTokenValid = !!token && !this.jwtHelper.isTokenExpired(token);
    } catch (e) {
      isTokenValid = false;
    }

    if (isTokenValid) {
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      // console.log(this.jwtHelper.decodeToken(token));
      return true;
    } 
    }else {
        if (token) {
        localStorage.removeItem('accessToken');
      }
      this.router.navigate(['/auth/login']);
    }
  }

}
